import request from '../request'

export function fetchList(params) {
    return request({
        url: '/model-analysis/pipe/well/list',
        params
    })
}
export function fetchDetail(data) {
    return request({
        url: `/model-analysis/pipe/well/query/${data.category}/${data.id}`,
        method:"post"
    })
}

export function add(data) {
    return request({
        url: `/model-analysis/pipe/well/add`,
        method: 'post',
        data
    })
}

export function edit(data) {
    return request({
        url: '/model-analysis/pipe/well/update',
        method: 'post',
        data
    })
}

export function del(data) {
    return request({
        url: '/model-analysis/pipe/well/delete',
        method: 'post',
        data
    })
}